// ─── DONNÉES CROISIÈRE PARTAGÉES (UI + worker) ───────────────────────────────
// Extraites d'App.js le 2026-06-10 (migration recette → worker). Ce module est
// importé par App.js (UI) ET par src/promptBuilder.js (bundlé dans le worker).
// Rien de sensible ici : listes d'affichage et helpers neutres seulement.

// Normalise l'origine du voyageur : code IATA 3 lettres, ou "-" (Kayak décidera)
export function resolveOriginCode(data) {
  const raw = (data?.origin_airport || "").trim().toUpperCase();
  if (!raw || raw === "OTHER") {
    const custom = (data?.origin_airport_custom || "").trim().toUpperCase();
    if (/^[A-Z]{3}$/.test(custom)) return custom;
    return "-"; // fallback Kayak choisit
  }
  if (/^[A-Z]{3}$/.test(raw)) return raw;
  return "-";
}

export const CRUISE_COMPANIES = [
  { v: "royal_caribbean", l: "Royal Caribbean",      icon: "👑" },
  { v: "norwegian",       l: "Norwegian Cruise Line", icon: "🇳🇴" },
  { v: "carnival",        l: "Carnival Cruise Line",  icon: "🎉" },
  { v: "celebrity",       l: "Celebrity Cruises",     icon: "⭐" },
  { v: "princess",        l: "Princess Cruises",      icon: "👸" },
  { v: "msc",             l: "MSC Cruises",            icon: "🌍" },
  { v: "holland_america", l: "Holland America Line",  icon: "⚓" },
  { v: "virgin",          l: "Virgin Voyages",         icon: "🔥" },
  { v: "costa",           l: "Costa Cruises",          icon: "🇮🇹", secondary: true },
  { v: "disney",          l: "Disney Cruise Line",     icon: "🏰", secondary: true },
  // Lignes de luxe / haut de gamme — regroupées et étiquetées dans le sélecteur
  // (commissions plus élevées, clientèle 55-65+ aisée). Flotte découverte à la volée
  // côté worker (discoverFleet) → recherche fonctionne même sans pré-indexation.
  { v: "oceania",         l: "Oceania Cruises",        icon: "🌊", secondary: true, luxury: true },
  { v: "regent",          l: "Regent Seven Seas",      icon: "💎", secondary: true, luxury: true },
  { v: "seabourn",        l: "Seabourn",               icon: "🥂", secondary: true, luxury: true },
  { v: "silversea",       l: "Silversea Cruises",      icon: "✨", secondary: true, luxury: true },
  // azamara EN HOLD (retirée du picker) — CruiseDirect ne la vend pas → pas de réservation
  // possible. Cf. mémoire project_azamara_hold. La rétablir si partenariat agence signé.
  { v: "cunard",          l: "Cunard",                  icon: "🎩", secondary: true, luxury: true },
  { v: "crystal",         l: "Crystal Cruises",        icon: "💠", secondary: true, luxury: true },
];

// Classes génériques (quand aucune compagnie choisie ou première croisière)
// Remplacé par t.generic_ship_classes au runtime — garder la version FR comme fallback
export const GENERIC_SHIP_CLASSES_FR = [
  { v: "mega",   l: "Méga-paquebot",  pax: "5 000+ passagers", s: "Ville flottante complète — toboggans géants, Broadway, 20+ restos, quartiers thématiques. Idéal famille active. (Icon, Oasis, World Europa, Excel)", icon: "🏙️" },
  { v: "large",  l: "Grand navire",   pax: "3 000–5 000 passagers", s: "Animation soutenue, diversité d'activités, excellent rapport qualité-prix. Le juste milieu. (Escape, Mardi Gras, Quantum, Vista)", icon: "🚢" },
  { v: "medium", l: "Navire moyen",   pax: "< 3 000 passagers", s: "Ambiance plus intime, moins de files d'attente, cuisine soignée. Parfait adultes & couples. (Prima, Edge Class, Rotterdam, Scarlet Lady)", icon: "⛵" },
  { v: "any",    l: "Peu importe",    pax: "Toutes tailles",    s: "Je veux la meilleure offre disponible — laissez l'IA choisir.", icon: "🎯" },
];
